import { Routes } from '@angular/router';
import { AdminLayoutComponent } from '../layouts/admin/admin.component';
import { OfficeComponent } from '../features/office/office.component';
import { AuthComponent } from '../features/auth/pages/auth.component';
import { ContentPageComponent } from '../features/admin/content/content-page.component';
import { DailyFactsComponent } from '../features/admin/daily-facts/daily-facts.component';
import { UsersComponent } from '../features/admin/users/users.component';
import { SettingsComponent } from '../features/admin/settings/settings.component';
import { BillingAdminComponent } from '../features/admin/billing/billing-admin.component';
import { PatrolComponent } from '../features/admin/patrol/patrol.component';
import { IdentityAdminComponent } from '../features/admin/identity/identity-admin.component';
import { AudienceAdminComponent } from '../features/admin/audience/audience.component';
import { PartnerIntegrationReviewComponent } from '../features/admin/identity/partner-integration-review.component';
import { AdminProfileComponent } from '../features/admin/profile/admin-profile.component';
import { ERole } from '../features/auth/enums/role.enum';
import { RoleGuard } from '../core/guards/role.guard';
import { AuthGuard } from '../core/guards/auth.guard';
import { ForgotPasswordRequestComponent } from '../features/auth/pages/forgot-password-request/forgot-password-request.component';
import { UpdatePasswordComponent } from '../features/auth/pages/update-password/update-password.component';
import {
  layoutRoleChildGuard,
  layoutRoleGuard,
} from '../core/guards/layout-role.guard';

export const getAdminRoutes = (): Routes => {
  return [
    {
      path: '',
      component: AdminLayoutComponent,
      data: { layout: 'admin', layoutRoles: [ERole.ADMIN] },
      canActivate: [layoutRoleGuard],
      canActivateChild: [layoutRoleChildGuard],
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'office',
        },
        {
          path: 'auth',
          component: AuthComponent,
        },
        {
          path: 'auth/forgot-password',
          component: ForgotPasswordRequestComponent,
        },
        {
          path: 'auth/update-password',
          component: UpdatePasswordComponent,
        },
        {
          path: 'office',
          canActivate: [AuthGuard, RoleGuard],
          component: OfficeComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'content',
          canActivate: [AuthGuard, RoleGuard],
          component: ContentPageComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'daily-facts',
          canActivate: [AuthGuard, RoleGuard],
          component: DailyFactsComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'users',
          canActivate: [AuthGuard, RoleGuard],
          component: UsersComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'patrol',
          canActivate: [AuthGuard, RoleGuard],
          component: PatrolComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'identity',
          canActivate: [AuthGuard, RoleGuard],
          component: IdentityAdminComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'audience',
          canActivate: [AuthGuard, RoleGuard],
          component: AudienceAdminComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'identity/integration-requests',
          canActivate: [AuthGuard, RoleGuard],
          component: PartnerIntegrationReviewComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'billing',
          canActivate: [AuthGuard, RoleGuard],
          component: BillingAdminComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'settings',
          canActivate: [AuthGuard, RoleGuard],
          component: SettingsComponent,
          data: { roles: [ERole.ADMIN] },
        },
        {
          path: 'profile',
          canActivate: [AuthGuard, RoleGuard],
          component: AdminProfileComponent,
          data: { roles: [ERole.ADMIN] },
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'office',
    },
  ];
};
